import React, { useRef, useEffect } from 'react';
import { useUser } from 'hooks/useUser';
import Boto from 'components/corporatiu/Boto';
import styles from './modalNoLogat.module.scss';

const ModalNoLogat = (props) => {
    const { onClickClose, optionsSign = {}, tancarModal = true } = props;
    const { signUp, signIn } = useUser();
    const initialFocusRef = useRef(null);

    useEffect(() => {
        if (initialFocusRef.current) {
            initialFocusRef.current.focus();
        }
        // Bloqueig scroll iOS
        const scrollY = window.scrollY;
        document.body.style.position = 'fixed';
        document.body.style.top = `-${scrollY}px`;
        document.body.style.width = '100%';

        return () => {
            const scrollY = document.body.style.top;
            document.body.style.position = '';
            document.body.style.top = '';
            document.body.style.width = '';
            if (scrollY) {
                window.scrollTo(0, parseInt(scrollY || '0') * -1);
            }
        };
    }, []);

    return (
        <div className={styles.modalNoLogat}>
            {tancarModal && (
                <Boto
                    onClick={onClickClose}
                    estil='noEstil'
                    tag='button'
                    className={styles.tancar}
                    ref={initialFocusRef}
                    icona='tanca'
                    mida={24}
                />
            )}
            <div className={styles.content}>
                <div className={styles.info}>
                    <h2 className={styles.titol}>Inicia sessió amb el teu compte 3Cat</h2>
                    <div className={styles.contentBotons}>
                        <Boto
                            tag='button'
                            text='Inicia sessió'
                            estil='ple3cat100'
                            altIcona='Inicia sessió'
                            dataTestId='butlletins-inicia-sessio'
                            onClick={() => signUp({ ...optionsSign })}
                            className={styles.boto}
                        />
                        <Boto
                            tag='button'
                            text='Crea el teu compte 3Cat'
                            estil='lined3cat100'
                            iconaInline={true}
                            altIcona='Crea el teu compte 3Cat'
                            dataTestId='butlletins-crea-compte'
                            onClick={() => signIn({ ...optionsSign })}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ModalNoLogat;
